import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { themeGet } from '@styled-system/theme-get';

import TextInput from '../../../../shared/FormStyles/TextInput.jsx';
import ToggleSwitch from '../../../../shared/FormStyles/ToggleSwitch.jsx';
import { Button, StyledSelect, Label } from '../../../../shared/FormStyles';
import useCreateUserForm from './useCreateUserForm.jsx';
import { useGetPopulationSegments } from '../../data';

const CreateUserForm = () => {
  const {
    handleChange,
    handleSubmit,
    values,
    inputError,
    handleBlur,
    disabledSubmit,
    setFieldValue,
  } = useCreateUserForm();
  const populationSegments = useGetPopulationSegments();

  const { t } = useTranslation('users');

  return (
    <Form onSubmit={handleSubmit}>
      <TextInput
        onChange={handleChange}
        value={values.name}
        name="name"
        label={t('userForm.name')}
        error={inputError('name')}
        onBlur={handleBlur}
        placeholder={t('userForm.namePlaceholder')}
        m="0 0 12px"
      />

      <TextInput
        onChange={handleChange}
        value={values.employeeId}
        name="employeeId"
        label={t('userForm.employeeId')}
        error={inputError('employeeId')}
        onBlur={handleBlur}
        placeholder={t('userForm.employeeIdPlaceholder')}
        m="12px 0"
      />

      <TextInput
        onChange={handleChange}
        value={values.email}
        name="email"
        label={t('userForm.email')}
        error={inputError('email')}
        onBlur={handleBlur}
        placeholder={t('userForm.emailPlaceholder')}
        m="12px 0"
      />

      <TextInput
        onChange={handleChange}
        value={values.phoneNumber}
        name="phoneNumber"
        label={t('userForm.phone')}
        error={inputError('phoneNumber')}
        onBlur={handleBlur}
        placeholder={t('userForm.phonePlaceholder')}
        m="12px 0"
      />
      <ToggleSwitch
        label={t('userForm.isAdmin')}
        onChange={handleChange}
        value={values.isAdmin}
        name="isAdmin"
        id="isAdmin"
        color="black.80"
        margin="12px 0"
        fontWeight="400"
      />
      {populationSegments.length > 0 && (
        <SelectWrapper>
          <Label htmlFor="populationSegmentSelect">
            {t('userForm.segments')}
          </Label>
          <StyledSelect
            placeholder={t('userForm.segments')}
            classNamePrefix="react-select"
            isMulti={true}
            isClearable={true}
            options={populationSegments}
            value={values.populationSegments}
            onChange={option => setFieldValue('populationSegments', option)}
            inputId="populationSegmentSelect"
          />
        </SelectWrapper>
      )}

      <Button
        alignSelf="flex-end"
        variant="containedBlue"
        type="submit"
        disabled={disabledSubmit}
      >
        {t('addUsers.submit')}
      </Button>
    </Form>
  );
};

export default CreateUserForm;

const SelectWrapper = styled.div`
  margin: 12px 0;

  .react-select__control {
    border: 1px solid ${themeGet('colors.black.20')} !important;
  }

  .react-select__input {
    input {
      margin: 0 !important;
    }
  }

  .react-select__placeholder {
    color: ${themeGet('colors.black.20')};
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
